import { useGetUserQuery } from 'src/common/slices';

export const useIsUserAuthenticated = (): boolean => {
  const { isSuccess } = useGetUserQuery();
  return isSuccess;
};
